// A price is only shown when it is a number greater than 0, everything else ("0", "0.00", "-", null) is not available
const isAvailablePrice = (price) => {
    if (typeof price === 'string') {
        price = price.replaceAll(',', '.')
    }
    const value = parseFloat(price)
    return Number.isFinite(value) && value > 0
}

const getPriceNotAvailableLabel = () => {
    const key = 'product-page.price-not-available'
    const label = window.globals ? window.globals.trans(key) : key
    return label && label !== key ? label : 'N/A'
}

export { isAvailablePrice, getPriceNotAvailableLabel }
